import { MunicipalityObject } from "@libs/types/src/list/object-type/municipality.object";
import { ComponentStoreV2Factory } from "../../../../shared/store/common/component-store-v2.factory";
import { computed, Injectable } from '@angular/core';
import { InfiniteScrollStore } from "../../../../shared/store/common/infinite-scroll.store";
import { municipalityFrag } from "./person-authorizations-dialog.query";

@Injectable()
export class PersonAuthorizationsDialogStore extends ComponentStoreV2Factory {
    public readonly municipalityScroll = new InfiniteScrollStore<MunicipalityObject>(
            this.api.getListMunicipalities,
            {},
            false,
            municipalityFrag,
        );
}
